// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"99707b29a4e1233653d4","532":"26f995d384df2b5f1d66","691":"7f0c93fc45b7ff9de89a"}[chunkId] + ".js";
};